import { DivContainer, DivContainer50 } from "common/components/divContainer";
import { Forecast } from "../../../../common/aypaForms/forecast";
import { Region } from "../../../../common/aypaForms/region";
import { Node } from "../../../../common/aypaForms/node";
import { Location } from "../../../../common/aypaForms/location";

interface Props {
    isLoadingEnabled: boolean
    showLocationAndNode: boolean
}
export const Nodal = ({ isLoadingEnabled, showLocationAndNode }: Props) => {

    /**Constants */
    const labelTitleRegion = "Region";
    const labelTitleForecast = "Forecast";
    const labelTitleNode = "Node";
    const labelTitleLocaiton = "Location";

    return (
        <>
            <DivContainer>
                <>
                    <DivContainer50 label={labelTitleRegion}>
                        <Region isLoadingEnabled={isLoadingEnabled} />
                    </DivContainer50>

                    <DivContainer50 label={labelTitleForecast}>
                        <Forecast isLoadingEnabled={isLoadingEnabled} />
                    </DivContainer50>

                </>
            </DivContainer>
            {showLocationAndNode && (
                <DivContainer>
                    <>
                        <DivContainer50 label={labelTitleLocaiton}>
                            <Location isLoadingEnabled={isLoadingEnabled} />
                        </DivContainer50>
                        <DivContainer50 label={labelTitleNode}>
                            <Node isLoadingEnabled={isLoadingEnabled} />
                        </DivContainer50>
                    </>
                </DivContainer>
            )}
        </>
    )
}